export class Globals {
    public getEntityTypes() {
        return [
            { id: 'TRUCKS', description: "TRUCKS" },
            { id: 'TRANSLOADER', description: "TRANSLOADER" },
            { id: 'TRANSLOADER/TRUCKS', description: "TRANSLOADER/TRUCKS" },
            { id: 'BARGE', description: "BARGE" },
            { id: 'LTL', description: "LTL" },
            { id: 'RAIL', description: "RAIL" },
            { id: 'VENDOR', description: "VENDOR" },
            { id: 'HOLDINGCOMPANY', description: "HOLDING COMPANY" }
        ];
    }
}